module.exports = __webpack_public_path__ + "img/standing-football-guy.8cba62b.svg";